import log from 'loglevel';
import { string, InferType } from 'yup';
import { removeEmptyValues } from '@move-frontend/utils';
import { getPublicConfig, publicConfigSchema } from './getPublicConfig';
import { Environment } from './types/Environment';

export const buildConfigSchema = publicConfigSchema
	.shape({
		contentfulSpace: string().required(),
		contentfulEnvironment: string().required(),
		contentfulAccessToken: string().required(),
		contentfulAccessTokenPreview: string().required(),
	})
	.required();

export type BuildConfig = InferType<typeof buildConfigSchema>;

let buildConfig: BuildConfig | undefined;

export function getBuildConfig() {
	if (buildConfig) {
		return buildConfig;
	}

	const publicConfig = getPublicConfig();

	const defaults: Partial<BuildConfig> = {
		...publicConfig,
		...getBuildConfigForEnvironment(publicConfig.environment as Environment),
	};

	const custom = getCustomBuildConfig();

	buildConfig = buildConfigSchema.validateSync({
		...defaults,
		...custom,
	});

	return buildConfig;
}

function getBuildConfigForEnvironment(environment?: Environment) {
	if (!environment) {
		return {};
	}

	switch (environment) {
		case Environment.Development:
			return {
				contentfulEnvironment: 'dev',
			};

		case Environment.Test:
			return {
				contentfulEnvironment: 'test',
			};

		case Environment.Acceptance:
			return {
				contentfulEnvironment: 'acceptance',
			};

		case Environment.Production:
			return {
				contentfulEnvironment: 'master',
			};

		default:
			log.warn('No default build config for unknown environment', environment);
			return {};
	}
}

function getCustomBuildConfig() {
	const customConfig: Partial<BuildConfig> = {
		contentfulSpace: process.env.CONTENTFUL_SPACE,
		contentfulEnvironment: process.env.CONTENTFUL_ENVIRONMENT,
		contentfulAccessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
		contentfulAccessTokenPreview: process.env.CONTENTFUL_ACCESS_TOKEN_PREVIEW,
	};

	return removeEmptyValues(customConfig);
}
